<template>
  <div class="video-player">
    <video
      :class="classArray"
      :height="size"
      :width="size"
      :muted="muted"
      @click="setMuted"
      webkit-playsinline="true"
      ref="currentVideo"
      preload="none"
      playsinline
      loop
    >
      <source ref="currentSourceVideo" type="video/mp4" />
    </video>
    <span class="soundIcon">
      <v-icon color="white" small> {{ getSoundIcon }} </v-icon>
    </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { forceSSL } from '@/helper/helper'
import { RegisterEvent } from '@/analytics'

export default {
  name: 'Video',

  props: {
    mediaSource: Object,
    keyPost: String,
    size: Number,
    classArray: Array,
    index: Number
  },
  computed: {
    ...mapGetters([
      'getMuted',
      'getVideoActive',
      'getVisibleIndexMin',
      'getVisibleIndexMax'
    ]),
    videoElement () {
      return this.$refs.video
    },
    muted () {
      return this.getMuted
    },
    getSoundIcon () {
      return this.getMuted ? 'mdi-volume-mute' : 'mdi-volume-high'
    },
    isActiveVideo () {
      return this.getVideoActive === this.keyPost
    },
    source () {
      return this.secureUrl(this.mediaSource.uri)
    },
    posterSource () {
      return this.secureUrl(this.mediaSource.poster) || this.poster_default
    },
    isLoadableInRange () {
      return (
        !(this.index < this.getVisibleIndexMin - 1) &&
        !(this.index > this.getVisibleIndexMax + 1)
      )
    }
  },
  watch: {
    isActiveVideo: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          newVal ? this.play() : this.stop()
        }
      },
      deep: true
    },
    isLoadableInRange: {
      handler: function (newVal, oldVal) {
        newVal ? this.startLoad() : this.stopLoad()
      }
    }
  },
  data: () => ({
    video: '',
    isVisible: false,
    isActive: false,
    startPlayTime: 0,
    lastVisibilityUpdated: 0,
    finishPlayTime: 0,
    lastSeek: 0,
    poster_default: require('@/assets/img/videoDefault.jpg')
  }),
  methods: {
    ...mapActions({
      mutedVideo: 'MUTED_VIDEO',
      appendVideo: 'VIDEO_APPEND',
      removeVideo: 'VIDEO_REMOVE'
    }),

    setMuted () {
      const isMuted = this.muted ? 'chi_video_mute' : 'chi_video_unmute'
      const result = this.mutedVideo(!this.muted)
      RegisterEvent(isMuted, {
        target_id: this.keyPost,
        target_type: 'post_id'
      })
      return result
    },
    secureUrl (url) {
      return url && forceSSL(url)
    },
    startLoad () {
      const source = this.$refs.currentSourceVideo
      if (source && !source.hasAttribute('src')) {
        source.setAttribute('src', this.source)
        this.$refs.currentVideo.load()
      }
    },
    stopLoad () {
      const source = this.$refs.currentSourceVideo
      if (source && source.hasAttribute('src')) {
        // this.stop()
        source.removeAttribute('src')
        this.$refs.currentVideo.load()
      }
    },
    playerHandler (entries) {
      const entry = entries[0]
      if (entry) {
        if (entry.isIntersecting) {
          setTimeout(() => {
            this.playerAction(entry)
          }, 50)
        } else {
          this.playerAction(entry)
        }
      }
    },
    playerAction (entry) {
      if (this.lastVisibilityUpdated < entry.time) {
        this.lastVisibilityUpdated = entry.time
        const isVisible = entry.isIntersecting
        this.isVisible = isVisible
        if (isVisible) {
          this.startLoad()
          this.appendVideo({ id: this.keyPost, index: this.index })
        } else {
          this.removeVideo({ id: this.keyPost })
        }
      }
    },
    seektimeupdate () {
      if (
        this.$refs.currentVideo &&
        (this.$refs.currentVideo.duration || 0) > 0
      ) {
        const currentDuration = this.$refs.currentVideo.duration || 0
        const currentTime = this.$refs.currentVideo.currentTime || 0
        const currentSeek = currentTime / currentDuration
        if (this.lastSeek > currentSeek) {
          RegisterEvent('chi_video_finished', {
            target_id: this.mediaSource.uri,
            target_type: 'video_url'
          })
        }
        this.lastSeek = currentSeek
      }
      return true
    },
    play: function () {
      // this.startPlay = true
      this.$refs.currentVideo.currentTime = 0
      this.$refs.currentVideo
        .play()
        .then(_ => {
          // this.startPlay = false
          // if (this.startStop) {
          //   this.startStop = false
          //   this.stop()
          // }
          this.startPlayTime = new Date().getTime()
        })
        .catch(error => error.message)
    },
    stop: function () {
      // this.startPlay ? this.startStop = true : this.$refs.currentVideo.pause()
      this.$refs.currentVideo.pause()
      if (this.startPlayTime > 0) {
        this.finishPlayTime = new Date().getTime()
        let duration = this.finishPlayTime - this.startPlayTime
        this.startPlayTime = 0
        this.finishPlayTime = 0
        if (parseInt(duration) >= 3000) {
          RegisterEvent('chi_video_display_duration', {
            target_id: this.keyPost,
            target_url: this.mediaSource.uri,
            target_type: 'post_id',
            duration: parseInt(duration / 1000)
          })
        }
      }
    }
  },
  mounted () {
    this.$refs.currentVideo &&
      this.$refs.currentVideo.addEventListener(
        'timeupdate',
        this.seektimeupdate,
        false
      )
    const observerPlayer = new IntersectionObserver(this.playerHandler, {
      threshold: this.index === 0 ? 0.8 : 0.35
    })
    observerPlayer.observe(this.$refs.currentVideo)
  },
  beforeDestroy () {
    this.stopLoad()
    this.removeVideo({ id: this.keyPost })

    this.$refs.currentVideo &&
      this.$refs.currentVideo.removeEventListener(
        'timeupdate',
        this.seektimeupdate,
        false
      )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/video.vue